import React from 'react';
import styles from '../../styles/ghostloader.module.scss';

export default function GhostLoader({ root = false }) {
    return (
        <div className={`${styles.overlay} ${root ? styles.root : styles.overlayBackdrop}`}>
            <div className={styles.loaderContainer}>
                <img src="/ap_loading.gif" alt="Loading" className={styles.loaderImage} />
            </div>
        </div>
    );
}